<template>
  <div class="pg-ocr-type">
    <slot></slot>
    <CollapseTransition :second="0.3">
      <div class="pg-ocr-type__box" v-show="show">
        <div class="pg-ocr-type__row" v-for="rowTtem in types" :key="rowTtem.code">
          <span class="pg-ocr-type__row-title">{{ rowTtem.title }}</span>
          <div class="pg-ocr-type__row-item-box">
            <div class="pg-ocr-type__row-item" v-for="item in rowTtem.btns" :key="item.code">
              <span class="pg-ocr-type__row-item-title">{{ item.title }}</span>
              <span class="pg-ocr-type__row-item-text">{{ item.text }}</span>
              <div class="pg-ocr-type__row-item-btns">
                <div class="pg-ocr-type__row-item-btns-l">
                  <PgOcrUpload
                    class="pg-ocr-type__row-item-btns-l-upload"
                    tips=""
                    @input="
                      (val) =>
                        uploadChang({
                          url: val,
                          code: rowTtem.code,
                          btnItem: item,
                          imgType: 'default',
                        })
                    "
                  ></PgOcrUpload>
                  <span class="pg-ocr-type__row-item-btns-l-text">支持JPG/PNG/PDF</span>
                </div>
                <span
                  class="pg-ocr-type__row-item-btns-high-shot"
                  @click="uploadChang({ code: rowTtem.code, btnItem: item, imgType: 'camera' })"
                  >高拍仪</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </CollapseTransition>
  </div>
</template>
<script setup>
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import PgOcrUpload from './upload.vue'

defineProps({
  show: {
    type: Boolean,
    default: true,
  },
  types: {
    type: Array,
    default: () => [
      {
        title: '普通类别',
        code: 'Advanced-group',
        btns: [
          {
            code: 'Advanced',
            title: '普通图片识别',
            text: '识别出图片中的文字， 可自行复制粘贴',
          },
        ],
      },
      {
        title: '发票类别',
        code: 'Invoice-group',
        btns: [
          {
            code: 'Invoice',
            title: '增值税发票识别',
            text: '识别后可以一键应用',
            tabs: [
              {
                title: '发票信息',
                children: [
                  {
                    title: '发票代码',
                    key: 'invoiceCode',
                  },
                  {
                    title: '发票号码',
                    key: 'invoiceNumber',
                  },
                  {
                    title: '开票日期',
                    key: 'invoiceDate',
                  },
                  {
                    title: '机器编码',
                    key: 'machineCode',
                  },
                  {
                    title: '校验码',
                    key: 'checkCode',
                  },
                  {
                    title: '受票方名称',
                    key: 'purchaserName',
                  },
                  {
                    title: '密码区',
                    key: 'passwordArea',
                  },
                  {
                    title: '不含税金额',
                    key: 'invoiceAmountPreTax',
                  },
                  {
                    title: '发票税额',
                    key: 'invoiceTax',
                  },
                  {
                    title: '大写金额',
                    key: 'totalAmountInWords',
                  },
                  {
                    title: '发票金额',
                    key: 'totalAmount',
                  },
                  {
                    title: '销售方名称',
                    key: 'sellerName',
                  },
                  {
                    title: '销售方税号',
                    key: 'sellerTaxNumber',
                  },
                  {
                    title: '销售方地址、电话',
                    key: 'sellerContactInfo',
                  },
                  {
                    title: '销售方开户行、账号',
                    key: 'sellerBankAccountInfo',
                  },
                  {
                    title: '开票人',
                    key: 'drawer',
                  },
                  {
                    title: '标题',
                    key: 'title',
                  },
                  {
                    title: '发票类型',
                    key: 'invoiceType',
                  },
                  {
                    title: '联次',
                    key: 'formType',
                  },
                  {
                    title: '机打发票代码',
                    key: 'printedInvoiceCode',
                  },
                  {
                    title: '机打发票号码',
                    key: 'printedInvoiceNumber',
                  },
                  {
                    title: '受票方开户行、账号',
                    key: 'purchaserBankAccountInfo',
                  },
                  {
                    title: '受票方地址、电话',
                    key: 'purchaserContactInfo',
                  },
                  {
                    title: '受票方税号',
                    key: 'purchaserTaxNumber',
                  },
                  {
                    title: '收款人',
                    key: 'recipient',
                  },
                  {
                    title: '备注',
                    key: 'remarks',
                  },
                  {
                    title: '复核人',
                    key: 'reviewer',
                  },
                  {
                    title: '特殊标识信息',
                    key: 'specialTag',
                  },
                ],
              },
              {
                title: '发票详情',
                key: 'invoiceDetails',
                children: [
                  {
                    title: '货物或应税劳务、服务名称',
                    key: 'itemName',
                  },
                  {
                    title: '规格型号',
                    key: 'specification',
                  },
                  {
                    title: '单位',
                    key: 'unit',
                  },
                  {
                    title: '数量',
                    key: 'quantity',
                  },
                  {
                    title: '单价',
                    key: 'unitPrice',
                  },
                  {
                    title: '金额',
                    key: 'amount',
                  },
                  {
                    title: '税率',
                    key: 'taxRate',
                  },
                  {
                    title: '税额',
                    key: 'tax',
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        title: '证照类别',
        code: 'licenses-group',
        btns: [
          {
            url: 'rest/ezcomp/ocr/documentKvTemplate2json/',
            code: 'Registration',
            title: '医疗器械注册证识别',
            text: '识别后可以一键应用',
            tabs: [
              {
                children: [
                  {
                    title: '注册证编号',
                    key: '注册证编号',
                  },
                  {
                    title: '注册人名称',
                    key: '注册人名称',
                  },
                  {
                    title: '注册人住所',
                    key: '注册人住所',
                  },
                  {
                    title: '生产地址',
                    key: '生产地址',
                  },
                  {
                    title: '代理人名称',
                    key: '代理人名称',
                  },
                  {
                    title: '代理人住所',
                    key: '代理人住所',
                  },
                  {
                    title: '产品名称',
                    key: '产品名称',
                  },
                  {
                    title: '规格/型号',
                    key: '包装规格',
                  },
                  {
                    title: '审批部门',
                    key: '审批部门',
                  },
                  {
                    title: '批准日期',
                    key: '批准日期',
                  },
                  {
                    title: '生效日期',
                    key: '生效日期',
                  },
                  {
                    title: '有效期至',
                    key: '有效期至',
                  },
                ],
              },
            ],
          },
          {
            code: 'BusinessLicense',
            title: '营业执照识别',
            text: '识别后可以一键应用',
            tabs: [
              {
                children: [
                  {
                    title: '统一社会信用代码',
                    key: 'creditCode',
                  },
                  {
                    title: '营业名称',
                    key: 'companyName',
                  },
                  {
                    title: '类型',
                    key: 'companyType',
                  },
                  {
                    title: '营业场所/住所',
                    key: 'businessAddress',
                  },
                  {
                    title: '法人/负责人',
                    key: 'legalPerson',
                  },
                  {
                    title: '经营范围',
                    key: 'businessScope',
                  },
                  {
                    title: '注册资本',
                    key: 'registeredCapital',
                  },
                  {
                    title: '注册日期',
                    key: 'RegistrationDate',
                  },
                  {
                    title: '营业期限',
                    key: 'validPeriod',
                  },
                  {
                    title: '格式化营业期限起始日期',
                    key: 'validFromDate',
                  },
                  {
                    title: '格式化营业期限终止日期',
                    key: 'validToDate',
                  },
                  {
                    title: '组成形式',
                    key: 'companyForm',
                  },
                ],
              },
            ],
          },
          {
            code: 'MedicalDeviceManageLicense',
            title: '医疗器械经营许可证识别',
            text: '识别后可以一键应用',
            tabs: [
              {
                children: [
                  {
                    title: '证照标题',
                    key: 'title',
                  },
                  {
                    title: '许可证编号',
                    key: 'licenseNumber',
                  },
                  {
                    title: '企业名称',
                    key: 'companyName',
                  },
                  {
                    title: '经营方式',
                    key: 'businessType',
                  },
                  {
                    title: '住所',
                    key: 'officeAddress',
                  },
                  {
                    title: '经营范围',
                    key: 'businessScope',
                  },
                  {
                    title: '经营场所',
                    key: 'businessAddress',
                  },
                  {
                    title: '库房/仓库地址',
                    key: 'warehouseAddress',
                  },
                  {
                    title: '发证日期',
                    key: 'issueDate',
                  },
                  {
                    title: '发证部门',
                    key: 'issueAuthority',
                  },
                  {
                    title: '法定代表人',
                    key: 'legalRepresentative',
                  },
                  {
                    title: '企业负责人',
                    key: 'responsiblePerson',
                  },
                  {
                    title: '质量管理人',
                    key: 'qualityManager',
                  },
                  {
                    title: '注册地址',
                    key: 'registeredAddress',
                  },
                  {
                    title: '有效期限/许可期限',
                    key: 'validToDate',
                  },
                ],
              },
            ],
          },
          {
            code: 'MedicalDeviceProduceLicense',
            title: '医疗器械生产许可证识别',
            text: '识别后可以一键应用',
            tabs: [
              {
                children: [
                  {
                    title: '注册地址',
                    key: 'registeredAddress',
                  },
                  {
                    title: '发证日期',
                    key: 'issueDate',
                  },
                  {
                    title: '许可证编号',
                    key: 'licenseNumber',
                  },
                  {
                    title: '发证部门',
                    key: 'issueAuthority',
                  },
                  {
                    title: '法定代表人',
                    key: 'legalRepresentative',
                  },
                  {
                    title: '生产地址',
                    key: 'productionAddress',
                  },
                  {
                    title: '企业负责人',
                    key: 'responsiblePerson',
                  },
                  {
                    title: '企业名称',
                    key: 'companyName',
                  },
                  {
                    title: '有效期限',
                    key: 'validToDate',
                  },
                  {
                    title: '住所',
                    key: 'officeAddress',
                  },
                  {
                    title: '生产范围',
                    key: 'productionScope',
                  },
                ],
              },
            ],
          },
          {
            code: 'ClassIIMedicalDeviceManageLicense',
            title: '第二类医疗器械经营备案凭证识别',
            text: '识别后可以一键应用',
            tabs: [
              {
                children: [
                  {
                    title: '备案编号',
                    key: 'recordNumber',
                  },
                  {
                    title: '企业名称',
                    key: 'companyName',
                  },
                  {
                    title: '住所',
                    key: 'officeAddress',
                  },
                  {
                    title: '经营场所',
                    key: 'businessAddress',
                  },
                  {
                    title: '库房地址',
                    key: 'warehouseAddress',
                  },
                  {
                    title: '经营方式',
                    key: 'businessType',
                  },
                  {
                    title: '法定代表人',
                    key: 'legalRepresentative',
                  },
                  {
                    title: '企业负责人',
                    key: 'responsiblePerson',
                  },
                  {
                    title: '经营范围',
                    key: 'businessScope',
                  },
                  {
                    title: '备案部门',
                    key: 'recordationAuthority',
                  },
                  {
                    title: '备案日期',
                    key: 'recordationDate',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
})
const emit = defineEmits(['on-upload'])

const uploadChang = (param) => {
  emit('on-upload', param)
}
</script>

<style lang="scss">
@import '../style/ocr-type.scss';
</style>
